import React from 'react'
import { FooterPortal } from './templates/FooterDesktop'
import { FooterSimple } from './templates/FooterSimple'


const Footer = (props) => {
    const {
        type
    } = props

    return (
        type === 'complete'
            ?
                <FooterPortal visible={null} />
            :
                type === 'simple'
                    ?
                        <FooterSimple />
                    : null
    )
}

export default Footer;